import React from 'react';


//Material-ui

class Comp extends React.Component {
	render() {
    let styleOuter = {
      position:'relative',
      display:'inline-block',
      margin:'3px',
      padding:'5px 10px',
      background:'#eee',
      textAlign:'left',
      zIndex:'10',
      color:'#999',
			borderRadius:'12px',
      fontSize:'0.9em',
    }

		let styleArrow = {
      position: 'absolute',
  		content: ' ',
  		bottom: '-10px',
  		right: '8px',
  		borderStyle: 'solid',
  		borderWidth: '12px 6px 0px 6px',
  		borderColor: '#eee transparent transparent transparent',
    }

		return (
			<div style={styleOuter}>
        <div style={styleArrow} />
        {this.props.children}
			</div>
		)
	}
}

export default Comp;
